// Baris "Rotasi Klinik <Bulan> <Tahun> belum diisi" di kartu "Perlu dilengkapi" Dashboard.
// Bulan lalu (sejak ROTASI_PENGINGAT_MULAI di server.py) hanya bila masih ada yg belum isi,
// terlama dulu; bulan berjalan selalu paling bawah (boleh 0 -> "Semua terisi").

export const BULAN_NAMA = [
    "", "Januari", "Februari", "Maret", "April", "Mei", "Juni",
    "Juli", "Agustus", "September", "Oktober", "November", "Desember",
];

// status=belum: tab Per Peserta langsung tersaring ke peserta yang Belum Isi.
const tautanMonitoring = (bulan, tahun) => `/rotasi-klinik?bulan=${bulan}&tahun=${tahun}&status=belum`;

export function barisPengingatRotasi(data) {
    if (!data) return [];
    const baris = (bulan, tahun, jumlah, testId) => ({
        key: `${tahun}-${bulan}`,
        label: `Rotasi Klinik ${BULAN_NAMA[bulan]} ${tahun} belum diisi`,
        jumlah,
        to: tautanMonitoring(bulan, tahun),
        testId,
    });
    const lalu = (data.rotasi_bulan_lalu || [])
        .filter((r) => r.belum_isi > 0)
        .slice()
        .sort((a, b) => a.tahun - b.tahun || a.bulan - b.bulan)
        .map((r) => baris(r.bulan, r.tahun, r.belum_isi, `perlu-rotasi-${r.tahun}-${String(r.bulan).padStart(2, "0")}`));
    return [...lalu, baris(data.rotasi_bulan, data.rotasi_tahun, data.rotasi_klinik_belum_isi, "perlu-rotasi")];
}
